import { render, staticRenderFns } from "./auto_mail.vue?vue&type=template&id=66b031d7&"
import script from "./auto_mail.vue?vue&type=script&lang=js&"
export * from "./auto_mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports